import styled, { css } from 'styled-components';

export const Button = styled.button(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: ${theme.sz.s2};
    box-sizing: border-box;
    width: 100%;
    margin: 0;
    padding: ${theme.sz.s3} ${theme.sz.s5};
    border: 0;
    border-radius: ${theme.bo.round};
    background-color: ${theme.co.secondary30};
    color: ${theme.co.neutral99};
    cursor: pointer;
    ${theme.typography.paragraph.m};
    font-weight: ${theme.DEPRECATED_ty.mediumWeight};

    &:hover {
      background-color: ${theme.co.secondary20};
    }

    svg {
      flex-shrink: 0;
      width: ${theme.sz.s5};
      height: ${theme.sz.s5};
    }
  `,
);
